import { useMemo } from "react";

import { BulkEntityActionItem } from "components/BulkActions/types";
import { Worker } from "types/generated";
import {
  canDrainWorkerWithPoolAccess,
  canUndrainWorkerWithPoolAccess,
} from "shared/WorkerPool/useSetWorkerDrain/accessValidation";
import { useBulkSetWorkerDrain } from "shared/WorkerPool/useSetWorkerDrain";
import { AccessResult } from "utils/access";

import { BulkPrivateWorkerPoolWorkersActions } from "./types";

const useWorkerBulkActions = (workerPoolId: string, canDrainWorkerPoolsAccess: AccessResult) => {
  const [setBulkWorkerDrain] = useBulkSetWorkerDrain();

  return useMemo<
    Array<BulkEntityActionItem<BulkPrivateWorkerPoolWorkersActions, Worker, undefined>>
  >(
    () => [
      {
        key: BulkPrivateWorkerPoolWorkersActions.DRAIN,
        title: "Drain",
        resultTitle: "Drain workers results",
        condition: (worker) => canDrainWorkerWithPoolAccess(worker, canDrainWorkerPoolsAccess),
        mutation: (worker) =>
          setBulkWorkerDrain({ id: worker.id, workerPool: workerPoolId, drain: true }),
      },
      {
        key: BulkPrivateWorkerPoolWorkersActions.UNDRAIN,
        title: "Undrain",
        resultTitle: "Undrain workers results",
        condition: (worker) => canUndrainWorkerWithPoolAccess(worker, canDrainWorkerPoolsAccess),
        mutation: (worker) =>
          setBulkWorkerDrain({ id: worker.id, workerPool: workerPoolId, drain: false }),
      },
    ],
    [setBulkWorkerDrain, workerPoolId, canDrainWorkerPoolsAccess]
  );
};

export default useWorkerBulkActions;
